import ArenaImage from './ArenaImage';
import Area from './Area';
import C from './Constants';
import Hammer from 'hammerjs';

import { gsap, Power2 } from 'gsap';
import Draggable from 'gsap/Draggable';

gsap.registerPlugin(Draggable);

export default class ChooseSection {

    constructor(props) {
        this.props = props;
        this.el = $('.choose-section');        

        this._onWheel = this._onWheel.bind(this);
        this.resetViewport = this.resetViewport.bind(this);        
        this.btnZoom = this.btnZoom.bind(this);
        this._onPinch = this._onPinch.bind(this);
        this._onPinchStart = this._onPinchStart.bind(this);
        this._onPinchEnd = this._onPinchEnd.bind(this);
        this._setNextSelection = this._setNextSelection.bind(this);
        this._setAvailabilityOnSections = this._setAvailabilityOnSections.bind(this);

        this._showLoader = this._showLoader.bind(this);
        this._hideLoader = this._hideLoader.bind(this);

        this.dataStorage = this.props.dataStorage;
        this.state = this.dataStorage.state;
        this.selectedOitem = 0;
        this.ungroupedIndex = 0;
        this.visibleHeight = 0;
        this.eventId = 0;
        this.eventId = parseInt($('.seat-suggestion').data('event-id'));

        if (!this.el) {
            return false;
        }       

        this.isOpen = false;
        this._hideLoader();
    }

    bind() {

        // Called to update
        if ($("#ChooseSection-Component").is(":visible")) {            
            this._setAvailabilityOnSections();
        }

    }

    open() {
        
        this.isOpen = true; 
        this._setupArenaImage();
        this._setupAreaMap();
        $(".btnAreaZoom").on("click", this.btnZoom);
       
    }

    _hideLoader() {
        let loader = $('.loader');
        if (loader)
            loader.hide();
    }

    _showLoader() {
        let loader = $('.loader');
        loader.show();
    }
   

_setupArenaImage() {

    if (this.arenaImage) {
        return false;
    }

    this.arenaImage = new ArenaImage(this.el.find('div.server-image'));          
}

  _setupAreaMap() {

    if (!this.arenaImage) {
      return false;
    }

    this.svg = document.querySelector("#svgareamap svg");
    if (this.svg) {

      this.svg.addEventListener("wheel", this._onWheel);
      $(".btnZoom").on("click", this.btnZoom);
      $("#btnToggleMap").on("click", this._toggleMiniMap);

      this.point = this.svg.createSVGPoint();
      this.startClient = this.svg.createSVGPoint();
      this.startGlobal = this.svg.createSVGPoint();


      // FOR MOBILE PINCH
      // =========================================================================== 
      this.isPinching = false;
      this.PinchCnt = 0;
      this.tPinching = null;
      this.startPinchPos = {};
      this.hammer = new Hammer(this.svg, { domEvents: true });
      this.hammer.get('pinch').set({ enable: true });

      this.hammer.on('pinchstart', this._onPinchStart);
      this.hammer.on('pinch', this._onPinch);
      this.hammer.on('pinchend', this._onPinchEnd);


      // VARIABLES
      this.proxy = document.createElement("div");
      this.viewBox = this.svg.viewBox.baseVal;
      this.isIOS12 = false;
      this.isIOS = false;
      if (/iP(hone|od|ad)/.test(navigator.platform)) {
        try {
          var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
          if (parseInt(v[1], 10) == "12") this.isIOS12 = true;
        } catch (e) {
        }
      }


      this.mapWidth = 0;
      this.mapHeight = 0;
      this.padding = { x: 100, y: 100 };

      // Check how much of the map is visible and possibly zoom the svg
      let elH = $(this.svg).outerHeight(),
        H = $(window).height() - 100,
        r = $(this.svg)[0].getBoundingClientRect(), t = r.top, b = r.bottom;

      if (this.visibleHeight === 0) {
        this.visibleHeight = Math.max(450, t > 0 ? Math.min(elH, H - t) : Math.min(b, H));
      }


      $(this.svg).height(this.visibleHeight);

      var displayAreaWidth = $("#svgareamap_parent")[0].clientWidth;
      $("#svgareamap").width(displayAreaWidth);
      setTimeout(function () {
        // Edge fix
        $("#svgareamap").width(displayAreaWidth);
      }, 50);
      var displayAreaHeight = $("#svgareamap_parent")[0].clientHeight;
      var displayRatio = displayAreaWidth / displayAreaHeight;



      this.mapWidth = this.viewBox.width + 20;
      this.mapHeight = this.viewBox.height + 20;

      this.mapWidth = this.mapHeight * displayRatio;
      if (this.mapWidth < this.viewBox.width + 20) {        
        this.mapWidth = this.viewBox.width + 20;
        this.mapHeight = this.mapWidth / displayRatio;
      }


      this._setAvailabilityOnSections();


      this.isDragging = false;
      this.lastPickedSeat = "";

      this.dragCnt = 0;

      this.isDragging = false;
      this.tDrag;

      this.cachedViewBox = {
        x: this.viewBox.x,
        y: this.viewBox.y,
        width: this.viewBox.width,
        height: this.viewBox.height
      };

      this.zoom = {
        animation: gsap.timeline(),
        scaleFactor: 1.6,
        duration: 0.5,
        ease: Power2.easeOut,
      };

      var _this = this;

      this.pannable = new Draggable(this.proxy, {
        throwResistance: 3000,
        minimumMovement: 6,
        allowNativeTouchScrolling: false,
        trigger: this.svg,
        throwProps: true,
        onPress: function (e) {

          if (!_this.instructionRemoved) {
            _this.instructionRemoved = true;
            gsap.to($('.instruction'), .75, {
              opacity: 0, onComplete: function () {
                $('.instruction').remove();
              }
            });
          }

          if (this.isIOS12 && this.isPinching) { return; }
          _this.selectDraggable(e, _this, this);
        },
        onDrag: function () {

          if (this.isIOS12 && this.isPinching) { return; }
          _this.dragCnt += 1;
          _this.isDragging = true;
          _this._onDrag(_this, this)
        },
        onThrowUpdate: function () {
          if (this.isIOS12 && this.isPinching) { return; }
          _this._onDrag(_this, this);
        },
        onDragStart: function () {
          if (this.isIOS12 && this.isPinching) { return; }
          _this.dragCnt = 0;
        },
        onDragEnd: function () {
          setTimeout(function () {
            _this.isDragging = false;
            _this.dragCnt = 0;
          }, 100);
        },
        onRelease: function () {
          setTimeout(function () {
            _this.isDragging = false;
            _this.dragCnt = 0;
          }, 100);
        }
      });

    }


  }

  _setAvailabilityOnSections() {
    let sections = this.arenaImage.getSections();
    let showSelectionToggle = false;
    this.dataStorage.showToggleUngroupCheckbox = true;     
    let oitemIds = this.dataStorage.GetCart().map(x => x.id);

    
    // First check if all tickets can be placed on any section
    sections.each((index, el) => { 
      el = $(el);
      let area = new Area(el);
      if (area.validShape()) {
        let section = this.props.onGetSectionByCode(area.section);
        if (section) {
          if (oitemIds.length && oitemIds.every(x => section.oitems.includes(x))) {
            showSelectionToggle = true;            
            return;
          }
        }
      }
    });
    
    if (!showSelectionToggle) {      
      // No section could seat all the tickets. Show only split locations
      this.state = C.STATE_SECTIONS_UNGROUPED;
      this.dataStorage.state = C.STATE_SECTIONS_UNGROUPED;
      this.props.onToogleVisibilityChange(false);
    }


    sections.each((index, el) => {
      el = $(el);
      let area = new Area(el);
      if (area.validShape()) {
        let section = this.props.onGetSectionByCode(area.section);
        if (section) {           
          area.available = false;
          if (this.state === C.STATE_SECTIONS_GROUPED) {
            if (oitemIds.length && oitemIds.every(x => section.oitems.includes(x))) {
              area.available = true;
            }
          } else {
            if (section.oitems.includes(this.dataStorage.GetSelectedSeat().id)) {
              area.available = true;
              showSelectionToggle = true;
            }
          }

          area.draw();
          if (area.available) {
            el.on('click touchend', e => {
              if (this.isPinching) { return; }
              if (this.isIOS12) {
                if (this.isDragging) { return; }
              } else {
                e.stopPropagation();
                e.preventDefault();
                e.stopImmediatePropagation();
              }

              if (this.isPinching) { this.isPinching = false; return };
              if (this.isDragging && this.dragCnt > 1) { return };

              this.isOpen = false;
              this.props.onChooseSectionClickArea(section.code); // which is then converted into a section again...

            });


          }

        }
      }
    });
  }
  onResize() {

    if (!this.isOpen) {
      return false;
    }
    this.resetViewport();

  }




    //
    //ON PINCH START
    //===========================================================================
    _onPinchStart(ev) {
        try {
            this.isPinching = true;

            this.point.x = ev.center.x;
            this.point.y = ev.center.y;
            var pinchZoomOriginCalc = this.point.matrixTransform(this.svg.getScreenCTM().inverse());

            this.pinchZoomOrigin = {
                x: pinchZoomOriginCalc.x,
                y: pinchZoomOriginCalc.y
            };

            this.startPinch = {
                x: this.viewBox.x,
                y: this.viewBox.y,
                width: this.viewBox.width,
                height: this.viewBox.height,                
            };
            
        } catch (e) {

        }
    }


    //
    //ON PINCH
    //===========================================================================
    _onPinch(ev) {

        this.isPinching = true;
        var _this = this;

        if (_this.zoom.animation.isActive()) { return; }

        try {

            var scale = Math.round(1000 / ev.scale) / 1000; // Normalize

            this.point.x = ev.center.x;
            this.point.y = ev.center.y;

            var x = this.startPinch.x - ((this.pinchZoomOrigin.x - this.startPinch.x)) * (scale - 1)
            var y = this.startPinch.y - ((this.pinchZoomOrigin.y - this.startPinch.y)) * (scale - 1)


            // Zoombounds
            let initW = this.viewBox.width;
            this.viewBox.width = (Math.min(this.startPinch.width * scale, this.cachedViewBox.width));
            this.viewBox.height = (Math.min(this.startPinch.height * scale, this.cachedViewBox.height));

            if (initW != this.viewBox.width) {
                this.viewBox.x = (Math.min(this.cachedViewBox.width - this.viewBox.width + this.padding.x, Math.max(x, 0)));
                this.viewBox.y = (Math.min(this.cachedViewBox.height - this.viewBox.height + this.padding.y, Math.max(y, 0)));
            }

        } catch (e) {
            console.log(e);
        }

        return;











    }


    //
    // ON PINCH OUT
    //===========================================================================
    _onPinchEnd(ev) {
        var _this = this;
        clearTimeout(_this.tPinching);
        _this.tPinching = setTimeout(function () {
            _this.isPinching = false;
            _this.PinchCnt = 0;
        }, 300);
    }



    //
    // RESET VIEWPORT
    // =========================================================================== 
    resetViewport() {
        if (!this.isOpen) {
            return false;
        }
         
        if (this.pannable.tween) {
            this.pannable.tween.kill();
        }
        
        // Check how much of the map is visible and possibly reduce the svgn
        let elH = $(this.svg).outerHeight(),
            H = $(window).height(),
            r = $(this.svg)[0].getBoundingClientRect(), t = r.top, b = r.bottom;

        let visibleHeight = Math.max(450, Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H)));
        $(this.svg).height(visibleHeight);

        this.mapWidth = 0;
        this.mapHeight = 0;
        this.padding = { x: 100, y: 100 };

        var displayAreaWidth = $("#svgareamap_parent")[0].clientWidth;
        var displayAreaHeight = $("#svgareamap_parent")[0].clientHeight;
        var displayRatio = displayAreaWidth / displayAreaHeight;
       
        this.mapWidth = this.cachedViewBox.width + 20;  
        this.mapHeight = this.cachedViewBox.height + 20;  
        
        this.mapWidth = this.mapHeight * displayRatio;
        if (this.mapWidth < this.cachedViewBox.width) {            
            this.mapWidth = this.cachedViewBox.width + 20;
            this.mapHeight = this.mapWidth / displayRatio;
        }

        

        // Keep scale zoom...
        this.viewBox.width = this.mapWidth;
        this.viewBox.height = this.mapHeight;

        this.viewBox.width = Math.min(this.viewBox.width, this.cachedViewBox.width);
        this.viewBox.height = Math.min(this.viewBox.height, this.cachedViewBox.height);
        

        this.viewBox.x = this.cachedViewBox.x;
        this.viewBox.y = this.cachedViewBox.y;
        

        return;

    }


    //
    //ON BTN ZOOM
    //===========================================================================    
    btnZoom(ev) {
        var scale = ev.target.getAttribute("data-scale");

        
        var fromVars = {
            ease: this.zoom.ease,
            x: this.viewBox.x,
            y: this.viewBox.y,
            width: this.viewBox.width,
            height: this.viewBox.height,            
        };

        // Calculate center
        var x = this.viewBox.x - ((this.viewBox.x + this.viewBox.width / 2) - this.viewBox.x) * (scale - 1);
        var y = this.viewBox.y - ((this.viewBox.y + this.viewBox.height / 2) - this.viewBox.y) * (scale - 1);
        this.viewBox.width *= scale;
        this.viewBox.height *= scale;

        // Zoombounds
        this.viewBox.width = Math.min(this.viewBox.width, this.cachedViewBox.width);
        this.viewBox.height = Math.min(this.viewBox.height, this.cachedViewBox.height);

        this.viewBox.x = Math.min(this.cachedViewBox.width - this.viewBox.width, Math.max(x, 0));
        this.viewBox.y = Math.min(this.cachedViewBox.height - this.viewBox.height, Math.max(y, 0));

        this.zoom.animation = gsap.from(this.viewBox, this.zoom.duration, fromVars);


    }


    //
    //ON WHEEL
    //===========================================================================
    _onWheel(event) {        
        event.preventDefault();
        var normalized;
        var delta = event.wheelDelta;

        if (delta) {
            normalized = (delta % 120) == 0 ? delta / 120 : delta / 12;
        } else {
            delta = event.deltaY || event.detail || 0;
            normalized = -(delta % 3 ? delta * 10 : delta / 3);
        }

        var scaleDelta = normalized > 0 ? 1 / this.zoom.scaleFactor : this.zoom.scaleFactor;

        this.point.x = event.clientX;
        this.point.y = event.clientY;
        var startPoint = this.point.matrixTransform(this.svg.getScreenCTM().inverse());

        var _this = this;
        var fromVars = {
            ease: this.zoom.ease,
            x: this.viewBox.x,
            y: this.viewBox.y,
            width: this.viewBox.width,
            height: this.viewBox.height,            
        };

        var x = this.viewBox.x - (startPoint.x - this.viewBox.x) * (scaleDelta - 1);
        var y = this.viewBox.y - (startPoint.y - this.viewBox.y) * (scaleDelta - 1);
        this.viewBox.width *= scaleDelta;
        this.viewBox.height *= scaleDelta;


        // Zoombounds         
        this.viewBox.width = Math.min(this.viewBox.width, this.cachedViewBox.width);
        this.viewBox.height = Math.min(this.viewBox.height, this.cachedViewBox.height);

        this.viewBox.x = Math.min(this.cachedViewBox.width - this.viewBox.width, Math.max(x, 0));
        this.viewBox.y = Math.min(this.cachedViewBox.height - this.viewBox.height, Math.max(y, 0));

        this.zoom.animation = gsap.from(this.viewBox, this.zoom.duration, fromVars);


    }


    //
    // SELECT DRAGGABLE
    // =========================================================================== 
    selectDraggable(event, _this, _this2) {
        try {           
            _this.startClient.x = _this2.pointerX;
            _this.startClient.y = _this2.pointerY;
            _this.startGlobal = _this.startClient.matrixTransform(_this.svg.getScreenCTM().inverse());


            // Right mouse button
            if (event.button === 2) {
                event.preventDefault();
                return;
            } else {

                gsap.set(this.proxy, {
                    x: _this2.pointerX,
                    y: _this2.pointerY
                });

                 
                if (event.target != null && event.target.className.baseVal.indexOf("section available") >= 0) {
                    _this.pannable.enable().update();
                } else {
                    _this.pannable.enable().update().startDrag(event);
                }

            }
        } catch (e) {
        }
    }


    //
    // on DRAG 
    // =========================================================================== 
    _onDrag(_this, _thisEl) {
        
        if (_this.isIOS12 && _this.isPinching) { return; }
        if (_this.zoom.animation.isActive()) { return; }
        if (!_this.pannable.isDragging) { return; }

        _this.point.x = _thisEl.x;
        _this.point.y = _thisEl.y;

        var moveGlobal = _this.point.matrixTransform(_this.svg.getScreenCTM().inverse());

        _this.viewBox.x -= (moveGlobal.x - _this.startGlobal.x);
        _this.viewBox.y -= (moveGlobal.y - _this.startGlobal.y);

        // Bound check
        _this.viewBox.x = Math.min(_this.cachedViewBox.width - _this.viewBox.width + this.padding.x, Math.max(_this.viewBox.x, -1 * this.padding.x));
        _this.viewBox.y = Math.min(_this.cachedViewBox.height - _this.viewBox.height + this.padding.y, Math.max(_this.viewBox.y, -1 * this.padding.y));


  }
   
   

  _setNextSelection() {
    var el = this.oitems[this.ungroupedIndex];
    this._setSelectedOitem(el);
  }

   
}
